import TIMActions from "../components/GridTableUtils/TIMActions";
import { roleLabel } from "./timFamily";

// columnsGroups is a factory so the "Type" column and the row actions can use
// the right role labels for the assessment's category (e.g. Executive).
export const columnsGroups = (category) => [
    {
        field: 'firstName',
        headerName: 'First Name',
        flex: 1
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        flex: 1
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1
    },
    {
        field: 'type',
        headerName: 'Type',
        flex: 1,
        valueFormatter: (value)=> roleLabel(value, category)
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1
    },
    {
        field: 'actions',
        headerName: 'ACTIONS',
        flex: 1,
        renderCell: (params) => <TIMActions {...params} category={category} />
    },
];